import Plugin from 'src/plugin-system/plugin.class';

export default class CustomTabsPlugin extends Plugin {

    init() {

        var thisEl = $(this.el);

        thisEl.find('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            var index = $(e.target).index();
            var width = $(e.target).outerWidth();
            thisEl.find('.nav-tabs__indicator').css('left', 'calc(' + width + 'px * ' + index + ')');
        });
        
    }

}
